import { render } from "./SchoolInvoice.vue?vue&type=template&id=317e7f1d&scoped=true&ts=true"
import script from "./SchoolInvoice.vue?vue&type=script&lang=ts"
export * from "./SchoolInvoice.vue?vue&type=script&lang=ts"

import "./SchoolInvoice.vue?vue&type=style&index=0&id=317e7f1d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317e7f1d"]])

export default __exports__